import styles from '@/components/directory/v2/list-view/EVsListComponent.module.css'
import EVsListItemComponent from '@/components/directory/v2/list-view/EVsListItemComponent'

const EVsListComponent = ({ result }) => {
  const { make, model_count, models } = result

  return (
    <div id={`category-${make}`} className={styles.container}>
      <div className={styles.title}>
        <span className={styles.make}>{make}</span>
        <span className={styles.count}>{model_count}</span>
      </div>
      <div className={styles.evsList}>
        {models.map((model, index) => (
          <EVsListItemComponent key={index} evModel={model} />
        ))}
      </div>
    </div>
  )
}

export default EVsListComponent
